import React from "react";
import "./App.css";
import NavBar from "./components/navBar/NavBar";
import CustomCarousel from "./components/carousel/Carousal";
import TitleMessage from "./components/title-message/TitleMessage";
import About from "./views/about/About";
import { Parallax } from "react-parallax";
import { Fade, Slide } from "react-awesome-reveal";
import Container from "react-bootstrap/Container";
import Skills from "./views/skills/Skills";
import Blog from "./views/blog-section/BlogSection";
import Projects from "./views/projects/projects";
import Contact from "./views/contact/Contact";
import Footer from "./components/footer/Footer";
import LexChat from "./components/lexChat/LexChat";

function App() {
  return (
    <div className="App" style={{ position: "relative" }}>
      <NavBar />
      <CustomCarousel />
      <TitleMessage />
      <div>
        <Parallax
          blur={{ min: -30, max: 30 }}
          bgImage={require("./assets/img/parallex/background.png")}
          bgImageAlt=""
          strength={-200}
        >
          <div>
            <Container className="container-box">
              <Fade direction="left" duration={2000} triggerOnce>
                <About />
              </Fade>
            </Container>
          </div>
        </Parallax>
      </div>
      <div>
        <div>
          <Container className="container-box">
            <Fade direction="right" duration={2000} triggerOnce>
              <Skills />
            </Fade>
          </Container>
        </div>

        <div>
          <Container className="container-box">
            <hr />
            <Slide direction="up" duration={1000} triggerOnce>
              <Projects />
            </Slide>
          </Container>
        </div>

        <div>
          <Container className="container-box">
            <hr />
            <Slide direction="left" duration={2000} triggerOnce>
              <Blog />
            </Slide>
          </Container>
        </div>
      </div>

      <div>
        <Container className="container-box">
          <hr />
          <Fade direction="up" duration={2000} triggerOnce>
            <Contact />
          </Fade>
        </Container>
      </div>
      <hr />
      <Footer />
      <LexChat />
    </div>
  );
}

export default App;
